const offClickMap = new Map();

export const sortWatchlists = (a, b) =>
    a.displayName.localeCompare(b.displayName);

/**
 * Function that attaches a click off handler when a dropdown or modal is shown
 * @param {String} clsName clsName to ignore in the click off handler (i.e. - dropdown that is shown)
 * @param {Function} closeAction function to toggle item
 * @param {*} e synthetic event passed from react click handler
 */
export function attachClickOffHandler(clsName, closeAction, e) {
    function offClickHandler(event) {
        const dropdownElement = document.querySelector(`.${clsName}`);
        const targetSource = event.target;
        let targetElement = event.target;
        do {
            if (targetElement === dropdownElement) {
                return;
            }
            targetElement = targetElement.parentNode;
        } while (targetElement);

        if (targetElement !== dropdownElement) {
            closeAction();
            document.removeEventListener('click', offClickHandler, {
                capture: true
            });
            // Hide content and prevent it from being shown again if clicking on the trigger
            if (offClickMap.get(clsName).target === targetSource) {
                event.stopPropagation();
            }
            offClickMap.delete(clsName);
        }
    }

    if (!offClickMap.has(clsName)) {
        e.persist();
        offClickMap.set(clsName, e);
        document.addEventListener('click', offClickHandler, {
            capture: true
        });
    }
}
